module.exports = __webpack_public_path__ + "img/question-mark-health-plan.f72fbb93.svg";